import { RoleType } from './../constants/role';
import { or } from '@/utils/functional'
import { ApiRespone, FileStatus, Project, User } from '@/types/index'
import { Asset } from '@/types'
import { secToTime } from './utils'
import { ReviewStatus } from '@/constants/metadata'
import { AssetType, MediaType } from '@/constants/types'
import { Store } from 'vuex'
import { State } from '@/store/state'
import { ProjectRole } from '@/constants/role'
import router from '@/routers';
import i18n from '@/i18n'

export function getFileDuration (file: Asset) {
  // const hiveType = getHiveType(file.type, file.subtype)
  if (or(isAudio, isVideo)(file)) {
    return file.media?.duration ? secToTime(file.media.duration) : ''
  } else {
    return ''
  }
}

export function getUserInfo () {
  const userInfoStr = localStorage.getItem('m_user_traits')
  return window.AUTH as User || (userInfoStr ? (JSON.parse(userInfoStr) as User) : null)
}

export function encodeVerify (code: string, type: string, verify = '') {
  return btoa(JSON.stringify({
    code,
    verify,
    type
  }))
}

export function isProject (file: Asset) {
  return file.media?.media_type === MediaType.Project
}

export function isVideo (file: Asset) {
  return file.media?.media_type === MediaType.Video
}

export function isAudio (file: Asset) {
  return file.media?.media_type === MediaType.Audio
}

export function isPicture (file: Asset) {
  return file.media?.media_type === MediaType.Picture
}

export function isFolder (file: Asset) {
  return file.type === AssetType.Folder
}

export function isDocument (file: Asset) {
  return file.media?.media_type === MediaType.Document
}

export function isOther (file: Asset) {
  return file.media?.media_type === MediaType.Other
}

export function isNote (file: Asset) {
  return file.media?.media_type === MediaType.Note
}

export function isDeleted (file: Asset) {
  return !!file.delete_time
}

export function isUploading (file: Asset) {
  return [FileStatus.Paused, FileStatus.Uploading, FileStatus.Queued].includes(file.state!)
}

export function compare (val1: any, val2: any) {
  if (val1 === undefined || val2 === undefined) {
    return val1 > val2
  } else if (typeof val1 === 'number') {
    return val1 - val2
  } else {
    return val1.toString().localeCompare(val2.toString())
  }
}

/**
 * 中文 英文 数字混合排序
 * @param _a 
 * @param _b 
 * @returns 
 */
export function mixSort (_a: any, _b: any) {
  const reg = /[a-zA-Z0-9]/
  // 比对仅针对字符串，数字参与对比会导致对比的字符串转为number类型，变成NaN
  const a = _a.toString()
  const b = _b.toString()
  // 比对0号位的原因是字符串中有可能出现中英文混合的情况，这种仅按首位排序即可
  if (reg.test(a[0]) || reg.test(b[0])) {
    if (a > b) {
      return 1
    } else if (a < b) {
      return -1
    } else {
      return 0
    }
  } else {
    return a.localeCompare(b)
  }
}

export function compareReviewStatus (file1: Asset, file2: Asset) {
  const status1 = file1.audit
  const status2 = file2.audit
  const orders = [
    void 0,
    ReviewStatus.NO_STATUS,
    ReviewStatus.IN_PROGRESS,
    ReviewStatus.APPROVED,
    ReviewStatus.DISAPPROVED,
    ReviewStatus.NEEDS_REVIEW,
  ]
  return orders.indexOf(status2) - orders.indexOf(status1)
}

export function backToHome () {
  router.push({
    name: 'home'
  })
  // location.href = `${window.ROUTE_PREFIX}/home`
}

export function handleUserLeave () {
  localStorage.setItem(`m_last_visit`, location.href)
}

export function canEdit (store: Store<State>) {
  return store.state.currentRole === ProjectRole.MANAGER || store.state.currentRole === ProjectRole.EDITOR
}

export function canDelete (store: Store<State>) {
  return store.state.currentRole === ProjectRole.MANAGER
}

export function canOperateProject (store: Store<State>) {
  return store.state.userInfo.role === RoleType.ADMINISTRATOR || store.state.userInfo.role === RoleType.OWNER
}

export function canPublish (store: Store<State>) {
  return store.state.userInfo.role === RoleType.ADMINISTRATOR || store.state.userInfo.role === RoleType.OWNER
}

export function canCollect (project: Project) {
  switch (project.role) {
    case ProjectRole.EDITOR:
      return !!(project.permission && project.permission.editor_can_collection)
    case ProjectRole.REVIEWER:
      return !!(project.permission && project.permission.reviewer_can_collection)
    default:
      return true
  }
}

export function canShare (project: Project) {
  switch (project.role) {
    case ProjectRole.EDITOR:
      return project.permission && project.permission.editor_can_share
    case ProjectRole.REVIEWER:
      return project.permission && project.permission.reviewer_can_share
    default:
      return true
  }
}

export function canDownload (project: Project) {
  switch (project.role) {
    case ProjectRole.EDITOR:
      return !!(project.permission && project.permission.editor_can_download)
    case ProjectRole.REVIEWER:
      return !!(project.permission && project.permission.reviewer_can_download)
    default:
      return true
  }
}

export function getAssetsSize (assets: Asset[]) {
  const getSize = (i: Asset) => isFolder(i) ? (i.space || 0) : (i.media?.size || 0)
  return assets.map(getSize).reduce((i, j) => {
    return i + j
  }, 0)
}

export function getErrorMessage (e: any) {
  if (e.code === 'SENTI.B00007') {
    return e.message
  }
  return i18n.global.t('common.serverError')
}